import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeesService {

  httpHeaderOptions: any;

  constructor(private http: HttpClient) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
  }

  getHODReportingHeadMaster(){
    return this.http.get(environment.apiEndpoint + 'employee_list_wo_pagination/', this.httpHeaderOptions);
  }

  getHODReportingHeadMasterByTeam(params){
    return this.http.get(environment.apiEndpoint + 'employee_list_wo_pagination/?'+params, this.httpHeaderOptions);
  }
  
  getEmployeeListWithOutDetails(params){
    return this.http.get(environment.apiEndpoint + 'employee_list_without_details/?'+params, this.httpHeaderOptions);
  }

  getFlexiEmployeeListWithOutDetails(params){
    return this.http.get(environment.apiEndpoint + 'v2/flexi_employee_list_without_details/?'+params, this.httpHeaderOptions);
  }

  // Grade Management apis  ////////////////

  getGradeList(){
    return this.http.get(environment.apiEndpoint + 'grade_add/', this.httpHeaderOptions);
  }

  getGradeListwithPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_grade_list/?'+params, this.httpHeaderOptions);
  }

  addGrade(data) {
    return this.http.post(environment.apiEndpoint + 't_core_grade_add/', data, this.httpHeaderOptions);
  }

  editGrade(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_grade_edit/' + id + '/', data, this.httpHeaderOptions);
  }

  deleteGrade(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_grade_delete/' + id + '/', data, this.httpHeaderOptions);
  }

  // Sub-grade Management apis /////////////

  getSubGradeList(){
    return this.http.get(environment.apiEndpoint + 'sub_grade_add/', this.httpHeaderOptions);
  }

  getSubGradeListwithPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_sub_grade_list/?'+params, this.httpHeaderOptions);
  }

  getSubGradeListwithOutPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_sub_grade_list_wp/?'+params, this.httpHeaderOptions);
  }

  addSubGrade(data) {
    return this.http.post(environment.apiEndpoint + 't_core_sub_grade_add/', data, this.httpHeaderOptions);
  }

  editSubGrade(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_sub_grade_edit/' + id + '/', data, this.httpHeaderOptions);
  }

  deleteSubGrade(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_sub_grade_delete/' + id + '/', data, this.httpHeaderOptions);
  }

  ///////

  getEmployeList(params) {
    return this.http.get(environment.apiEndpoint + 'employee_list/?'+params, this.httpHeaderOptions);
  }

  exportEmployeList(params) {
    return this.http.get(environment.apiEndpoint + 'employee_list_export_download/?'+params, this.httpHeaderOptions);
  }

  deactivateEmployee(id:number,data: any) {
    return this.http.put(environment.apiEndpoint + 'employee_lock_unlock/'+id+'/', data,this.httpHeaderOptions);
  }
  addEmployee(data: any) {
    return this.http.post(environment.apiEndpoint + 'employee_add/', data);
  }
  
  importCSV(data: any) {
    return this.http.post(environment.apiEndpoint + 'employee_add_by_csv_or_excel/', data);
  }

  // Designation Management apis  ////////////

  getDesignation() {
    return this.http.get(environment.apiEndpoint + 't_core_designation_add/', this.httpHeaderOptions);
  }

  getDesignationListwithPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_designation_list/?'+params, this.httpHeaderOptions);
  }

  addDesignation(data) {
    return this.http.post(environment.apiEndpoint + 't_core_designation_add/', data, this.httpHeaderOptions);
  }

  editDesignation(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_designation_edit/' + id + '/', data, this.httpHeaderOptions);
  }

  deleteDesignation(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_designation_delete/' + id + '/', data, this.httpHeaderOptions);
  }

  //  Department Management apis //////////////////

  getDepartment() {
    return this.http.get(environment.apiEndpoint + 't_core_department_add/', this.httpHeaderOptions);
  }

  getSubDepartment(id: number) {
    return this.http.get(environment.apiEndpoint + 't_core_sub_department/'+id+'/', this.httpHeaderOptions);
  }

  getDepartmentListwithPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_department_list/?'+params, this.httpHeaderOptions);
  }

  addDepartment(data) {
    return this.http.post(environment.apiEndpoint + 't_core_department_add/', data, this.httpHeaderOptions);
  }

  editDepartment(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_department_edit/' + id + '/', data, this.httpHeaderOptions);
  }

  deleteDepartment(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_department_delete/' + id + '/', data, this.httpHeaderOptions);
  }

  //

  getEmployeeDetails(id:number,params) {
    return this.http.get(environment.apiEndpoint + 'employee_edit/'+id+'/?'+params, this.httpHeaderOptions);
  }
  getBenifitsMaster() {
    return this.http.get(environment.apiEndpoint + 'hrms_benefits_provided_add/', this.httpHeaderOptions);
  }
  getFacilitiesMaster() {
    return this.http.get(environment.apiEndpoint + 'hrms_other_facilities_add/', this.httpHeaderOptions);
  }

  //  Company Management apis ///////////////
  
  getCompany() {
    return this.http.get(environment.apiEndpoint + 't_core_company_add/', this.httpHeaderOptions);
  }

  getCompanyListwithPagination(params:any) {
    return this.http.get(environment.apiEndpoint + 't_core_comapny_list/?'+params, this.httpHeaderOptions);
  }

  addCompany(data) {
    return this.http.post(environment.apiEndpoint + 't_core_company_add/', data, this.httpHeaderOptions);
  }

  editCompany(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_company_edit/' + id + '/', data, this.httpHeaderOptions);
  }

  deleteCompany(id, data) {
    return this.http.put(environment.apiEndpoint + 't_core_comapny_delete/' + id + '/', data, this.httpHeaderOptions);
  }

  // 

  updateEmployeeRole(id: number,params, data: any): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'employee_edit/' + id + '/?'+params, data)
  }
 
  deleteDocument(id: number): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'hrms_employee_document_delete/' + id  + '/', {}, this.httpHeaderOptions)
  }
  deleteProfileDocument(id: number): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'hrms_employee_profile_document_delete/' + id  + '/', {}, this.httpHeaderOptions)
  }

  addDocument(data: any) {
    return this.http.post(environment.apiEndpoint + 'hrms_employee_document_add/', data);
  }
  addPersonalTabDocument(data: any) {
    return this.http.post(environment.apiEndpoint + 'hrms_employee_profile_document_add/', data);
  }

  getQualificationMaster(){
    return this.http.get(environment.apiEndpoint + 'qualification_master_add/', this.httpHeaderOptions);
  }

  academicQualificationAdd(data:any): Observable<any>{
    return this.http.post(environment.apiEndpoint + 'hrms_employee_academic_qualification_add/', data);
  }

  academicQualificationDocAdd(data:any): Observable<any>{
    return this.http.post(environment.apiEndpoint + 'hrms_employee_academic_qualification_document_add/', data);
  }

  academicQualificationDelete(id: number): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'hrms_employee_academic_qualification_delete/' + id  + '/', {}, this.httpHeaderOptions)
  }
  
  getEmployeeSalaryType(){
    return this.http.get(environment.apiEndpoint + 't_core_salary_type_add/', this.httpHeaderOptions);
  }
  
  getEmployeeReportForHR(params){
    return this.http.get(environment.apiEndpoint + 'employee_list_for_hr/?'+params, this.httpHeaderOptions);
  }

  exportEmployeeReportForHR(){
    return this.http.get(environment.apiEndpoint + 'employee_list_for_hr_export_download/', this.httpHeaderOptions);
  }

  getNewJoiners(params){
    return this.http.get(environment.apiEndpoint + 'v2/attendance_new_joiner_report/?'+params, this.httpHeaderOptions);
  }

  exportNewJoiners(params){
    return this.http.get(environment.apiEndpoint + 'v2/attendance_new_joiner_report_export_download/?'+params, this.httpHeaderOptions);
  }
  
  getWorkFromHomeReportList(params) {
    return this.http.get(environment.apiEndpoint + 'v2/work_from_home_report/?'+params, this.httpHeaderOptions);
  }

  downloadWorkFromHomeReport(params) {
    return this.http.get(environment.apiEndpoint + 'v2/work_from_home_report/download/?'+params, this.httpHeaderOptions);
  }

  verifyPassword(data: any) {
    return this.http.post(environment.apiEndpoint + 'v2/employee_view_password_verification/', data);
  }

}
